// extracted by mini-css-extract-plugin
module.exports = {"list":"Tabs_list__dawOh","item":"Tabs_item__3vrZE","underline":"Tabs_underline__3EfnL","segmented":"Tabs_segmented__3D6Y_","itemActive":"Tabs_itemActive__2Xu_q"};